import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3baacd4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language-container" }
const _hoisted_2 = {
  key: 0,
  class: "flag-container"
}
const _hoisted_3 = ["src"]

import { useI18n } from "vue-i18n";
import { useUserStore } from "@/store/userStore";
import { ref, onMounted, watch } from "vue";

// Import flags
import flagEnSrc from "@/assets/flags/gb.png";
import flagRuSrc from "@/assets/flags/ru.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

const { locale } = useI18n();
const userStore = useUserStore();
const selectedLanguage = ref(userStore.language);
const languages = [
  { value: "en", title: "En" },
  { value: "ru", title: "Ru" },
];

const selectedFlag = ref(flagEnSrc);

// Function to get flag URL based on language value
const getFlagURL = (value: string) => {
  switch (value) {
    case "en":
      return flagEnSrc;
    case "ru":
      return flagRuSrc;
    default:
      return "";
  }
};

onMounted(() => {
  locale.value = selectedLanguage.value;
  selectedFlag.value = getFlagURL(selectedLanguage.value);
});

// Watch for changes to selectedLanguage
watch(selectedLanguage, (newLanguage) => {
  console.log("Watcher Triggered: Language to change is", newLanguage);
  locale.value = newLanguage;
  userStore.setLanguage(newLanguage);
  selectedFlag.value = getFlagURL(newLanguage);
});

const changeLanguage = (value: string) => {
  console.log("Changing Language to:", value);
  selectedLanguage.value = value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_select, {
      modelValue: selectedLanguage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
      items: languages,
      "item-value": "value",
      "item-title": "title",
      onChange: changeLanguage,
      class: "language-selector",
      density: "compact"
    }, null, 8, ["modelValue"]),
    (selectedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: selectedFlag.value,
            class: "flag-image"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})